// // src/components/TaskDetailDrawer.jsx
// import React, { useState } from "react";
// import { XMarkIcon, PaperClipIcon, ClockIcon } from "@heroicons/react/24/outline";

// export default function TaskDetailDrawer({ task, open, onClose, onMarkComplete, onRequestApproval }) {
//   if (!open || !task) return null;

//   return (
//     <div className={`fixed inset-y-0 right-0 w-full max-w-md bg-white dark:bg-gray-900 shadow-2xl z-50 transform transition-transform duration-300 ${open ? "translate-x-0" : "translate-x-full"} overflow-y-auto`}>
//       <div className="sticky top-0 bg-white dark:bg-gray-900 border-b p-5 flex justify-between items-center">
//         <h2 className="text-2xl font-bold text-gray-900 dark:text-white">{task.title}</h2>
//         <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
//           <XMarkIcon className="w-6 h-6" />
//         </button>
//       </div>

//       <div className="p-6 space-y-6">
//         {/* Status & Priority */}
//         <div className="grid grid-cols-2 gap-4">
//           <div>
//             <label className="text-sm text-gray-500">Status</label>
//             <select className="w-full mt-1 p-2 border rounded-lg" defaultValue={task.status}>
//               <option>In Progress</option>
//               <option>Pending</option>
//               <option>Completed</option>
//             </select>
//           </div>
//           <div>
//             <label className="text-sm text-gray-500">Priority</label>
//             <select className="w-full mt-1 p-2 border rounded-lg" defaultValue={task.priority}>
//               <option>Low</option>
//               <option>Medium</option>
//               <option>High</option>
//             </select>
//           </div>
//         </div>

//         {/* Due Date */}
//         <div>
//           <label className="text-sm text-gray-500">Due Date</label>
//           <p className="mt-1 font-medium">{new Date(task.due_date).toLocaleDateString("en-GB", { day: "numeric", month: "long" })}, {new Date(task.due_date).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}</p>
//         </div>

//         {/* Assigned To */}
//         <div>
//           <label className="text-sm text-gray-500">Assigned To</label>
//           <p className="mt-1 font-medium">{task.assignee_name}</p>
//         </div>

//         {/* Related Record */}
//         <div>
//           <label className="text-sm text-gray-500">Related Module</label>
//           <p className="mt-1 font-medium text-blue-600">{task.module} #{task.related_record_id}</p>
//         </div>

//         {/* Notes */}
//         {task.notes && (
//           <div>
//             <h3 className="font-medium mb-2">Notes</h3>
//             <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
//               {task.notes.split("\n").filter(n => n.trim()).map((note, i) => (
//                 <li key={i}>{note.replace(/^- /, "")}</li>
//               ))}
//             </ul>
//           </div>
//         )}

//         {/* Attachments */}
//         {task.attachments?.length > 0 && (
//           <div>
//             <h3 className="font-medium mb-2">Attachments</h3>
//             <div className="space-y-2">
//               {task.attachments.map((file, i) => (
//                 <div key={i} className="flex items-center gap-2 text-sm">
//                   <PaperClipIcon className="w-5 h-5 text-gray-500" />
//                   <a href={file.url} className="text-blue-600 hover:underline">{file.name}</a>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Approval Status */}
//         {task.requires_approval && (
//           <div>
//             <h3 className="font-medium mb-2">Approvals</h3>
//             <div className="flex items-center gap-2 text-amber-700 bg-amber-50 px-4 py-2 rounded-lg">
//               <ClockIcon className="w-5 h-5" />
//               <span>Waiting for Manager Approval</span>
//             </div>
//           </div>
//         )}

//         {/* Action Buttons */}
//         <div className="flex gap-3 pt-6 border-t">
//           <button
//             onClick={onMarkComplete}
//             className="flex-1 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium"
//           >
//             Mark Complete
//           </button>
//           {task.requires_approval && task.status !== "Needs Approval" && (
//             <button
//               onClick={onRequestApproval}
//               className="flex-1 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-medium"
//             >
//               Request Approval
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// // src/components/Task/TaskDetailDrawer.jsx
// import React from "react";
// import { 
//   XMarkIcon, 
//   CalendarIcon, 
//   UserIcon, 
//   FlagIcon, 
//   ClockIcon, 
//   PaperClipIcon,
//   ClipboardDocumentIcon   // ← Added this import
// } from "@heroicons/react/24/outline";

// const statusConfig = {
//   Pending: { color: "text-amber-700", bg: "bg-amber-100" },
//   "In Progress": { color: "text-blue-700", bg: "bg-blue-100" },
//   "Needs Approval": { color: "text-purple-700", bg: "bg-purple-100" },
//   Completed: { color: "text-green-700", bg: "bg-green-100" },
//   Approved: { color: "text-green-700", bg: "bg-green-100" },
//   Rejected: { color: "text-red-700", bg: "bg-red-100" },
// };

// export default function TaskDetailDrawer({ task, open, onClose }) {
//   if (!open || !task) return null;

//   const formatDate = (date) => date ? new Date(date).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) : "—";
//   const formatTime = (date) => date ? new Date(date).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) : "";

//   const isOverdue = task.due_date && new Date(task.due_date) < new Date() && !["Completed", "Approved"].includes(task.status);

//   return (
//     <div
//       className={`fixed inset-y-0 right-0 w-full max-w-lg bg-white dark:bg-gray-900 shadow-2xl z-50 transform transition-transform duration-300 ease-in-out overflow-y-auto ${
//         open ? "translate-x-0" : "translate-x-full"
//       }`}
//     >
//       {/* Header */}
//       <div className="sticky top-0 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 p-6 flex justify-between items-center">
//         <h2 className="text-2xl font-bold text-gray-900 dark:text-white">{task.title}</h2>
//         <button
//           onClick={onClose}
//           className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition"
//         >
//           <XMarkIcon className="w-6 h-6 text-gray-600 dark:text-gray-400" />
//         </button>
//       </div>

//       <div className="p-6 space-y-8">
//         {/* Status Badge */}
//         <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full font-medium text-sm ${statusConfig[task.status]?.bg || "bg-gray-100"} ${statusConfig[task.status]?.color || "text-gray-700"}`}>
//           <ClockIcon className="w-5 h-5" />
//           {task.status}
//         </div>

//         {/* Key Details Grid */}
//         <div className="grid grid-cols-1 gap-6 text-sm">
//           {/* Priority */}
//           <div className="flex items-center gap-3">
//             <FlagIcon className="w-5 h-5 text-gray-500" />
//             <div>
//               <p className="text-gray-500">Priority</p>
//               <p className="font-semibold text-gray-900 dark:text-white">{task.priority || "—"}</p>
//             </div>
//           </div>

//           {/* Due Date */}
//           <div className="flex items-center gap-3">
//             <CalendarIcon className="w-5 h-5 text-gray-500" />
//             <div>
//               <p className="text-gray-500">Due Date</p>
//               <p className={`font-semibold ${isOverdue ? "text-red-600" : "text-gray-900 dark:text-white"}`}>
//                 {formatDate(task.due_date)} {task.due_date && `at ${formatTime(task.due_date)}`}
//                 {isOverdue && <span className="ml-2 text-xs font-bold bg-red-100 text-red-700 px-2 py-1 rounded">OVERDUE</span>}
//               </p>
//             </div>
//           </div>

//           {/* Assigned To */}
//           <div className="flex items-center gap-3">
//             <UserIcon className="w-5 h-5 text-gray-500" />
//             <div>
//               <p className="text-gray-500">Assigned To</p>
//               <p className="font-semibold text-gray-900 dark:text-white">{task.assignee_name || "Unassigned"}</p>
//             </div>
//           </div>

//           {/* Related Module & Record */}
//           <div className="flex items-center gap-3">
//             <ClipboardDocumentIcon className="w-5 h-5 text-gray-500" />
//             <div>
//               <p className="text-gray-500">Related Module</p>
//               <p className="font-semibold text-blue-600">
//                 {task.module || "General"} {task.related_record_id ? `#${task.related_record_id}` : ""}
//                 {task.related_record_name && ` — ${task.related_record_name}`}
//               </p>
//             </div>
//           </div>

//           {/* Client */}
//           {task.related_record_name && (
//             <div className="flex items-center gap-3">
//               <UserIcon className="w-5 h-5 text-gray-500" />
//               <div>
//                 <p className="text-gray-500">Client / Record</p>
//                 <p className="font-semibold text-gray-900 dark:text-white">{task.related_record_name}</p>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Notes */}
//         {task.notes && (
//           <div>
//             <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Notes</h3>
//             <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg text-sm text-gray-700 dark:text-gray-300 whitespace-pre-line">
//               {task.notes}
//             </div>
//           </div>
//         )}

//         {/* Attachments */}
//         {task.attachments && task.attachments.length > 0 && (
//           <div>
//             <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Attachments</h3>
//             <div className="space-y-2">
//               {task.attachments.map((file, i) => (
//                 <div key={i} className="flex items-center gap-3 text-sm bg-gray-50 dark:bg-gray-800 p-3 rounded-lg">
//                   <PaperClipIcon className="w-5 h-5 text-gray-500" />
//                   <a href={file.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
//                     {file.name || "Attachment"}
//                   </a>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Progress Timeline */}
//         <div>
//           <h3 className="font-semibold text-gray-900 dark:text-white mb-4">Progress Timeline</h3>
//           <div className="space-y-4">
//             {/* Created */}
//             <div className="flex gap-4">
//               <div className="flex flex-col items-center">
//                 <div className="w-4 h-4 rounded-full bg-blue-600"></div>
//                 <div className="w-0.5 bg-gray-300 flex-1 mt-2"></div>
//               </div>
//               <div>
//                 <p className="font-medium">Task Created</p>
//                 <p className="text-sm text-gray-500">{new Date(task.created_at).toLocaleString("en-IN")}</p>
//                 <p className="text-sm text-gray-600">by {task.creator_name || "System"}</p>
//               </div>
//             </div>

//             {/* Assigned */}
//             {task.assigned_at && (
//               <div className="flex gap-4">
//                 <div className="flex flex-col items-center">
//                   <div className="w-4 h-4 rounded-full bg-indigo-600"></div>
//                   <div className="w-0.5 bg-gray-300 flex-1 mt-2"></div>
//                 </div>
//                 <div>
//                   <p className="font-medium">Assigned</p>
//                   <p className="text-sm text-gray-500">{new Date(task.assigned_at).toLocaleString("en-IN")}</p>
//                   <p className="text-sm text-gray-600">to {task.assignee_name}</p>
//                 </div>
//               </div>
//             )}

//             {/* Completed */}
//             {task.completed_at && (
//               <div className="flex gap-4">
//                 <div className="flex flex-col items-center">
//                   <div className="w-4 h-4 rounded-full bg-purple-600"></div>
//                   {task.approved_at && <div className="w-0.5 bg-gray-300 flex-1 mt-2"></div>}
//                 </div>
//                 <div>
//                   <p className="font-medium">Marked Complete</p>
//                   <p className="text-sm text-gray-500">{new Date(task.completed_at).toLocaleString("en-IN")}</p>
//                 </div>
//               </div>
//             )}

//             {/* Approved / Rejected */}
//             {task.approved_at && (
//               <div className="flex gap-4">
//                 <div className="flex flex-col items-center">
//                   <div className={`w-4 h-4 rounded-full ${task.status === "Rejected" ? "bg-red-600" : "bg-green-600"}`}></div>
//                 </div>
//                 <div>
//                   <p className="font-medium">{task.status === "Rejected" ? "Rejected" : "Approved"}</p>
//                   <p className="text-sm text-gray-500">{new Date(task.approved_at).toLocaleString("en-IN")}</p>
//                   <p className="text-sm text-gray-600">by {task.approver_name || "Manager"}</p>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// src/components/Task/TaskDetailDrawer.jsx


import React from "react";
import {
  XMarkIcon,
  CalendarIcon,
  UserIcon,
  FlagIcon,
  ClockIcon,
  ClipboardDocumentIcon,
} from "@heroicons/react/24/outline";

const statusConfig = {
  Pending: { color: "text-amber-700", bg: "bg-amber-100" },
  "In Progress": { color: "text-blue-700", bg: "bg-blue-100" },
  "Needs Approval": { color: "text-purple-700", bg: "bg-purple-100" },
  Completed: { color: "text-green-700", bg: "bg-green-100" },
  Approved: { color: "text-green-700", bg: "bg-green-100" },
  Rejected: { color: "text-red-700", bg: "bg-red-100" },
};

export default function TaskDetailDrawer({ task, open, onClose }) {
  if (!open || !task) return null;

  const formatDate = (date) =>
    date
      ? new Date(date).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })
      : "—";

  const isOverdue =
    task.due_date &&
    new Date(task.due_date) < new Date() &&
    !["Completed", "Approved"].includes(task.status);

  return (
    <div className={`fixed inset-y-0 right-0 w-full max-w-2xl bg-white shadow-2xl z-50 transform transition-transform duration-300 ${
      open ? "translate-x-0" : "translate-x-full"
    } overflow-y-auto`}>
      <div className="sticky top-0 bg-white border-b p-6 flex justify-between items-center">
        <h2 className="text-3xl font-bold text-gray-900">{task.title}</h2>
        <button onClick={onClose} className="p-3 rounded-full hover:bg-gray-100">
          <XMarkIcon className="w-8 h-8 text-gray-600" />
        </button>
      </div>

      <div className="p-8 space-y-8">
        {/* Status Badge */}
        <div className={`inline-flex items-center gap-3 px-6 py-3 rounded-full font-bold text-lg ${statusConfig[task.status]?.bg || "bg-gray-100"} ${statusConfig[task.status]?.color || "text-gray-700"}`}>
          <ClockIcon className="w-6 h-6" />
          {task.status}
        </div>

        {/* Key Details */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-lg">
          <div className="flex items-center gap-4">
            <FlagIcon className="w-8 h-8 text-gray-500" />
            <div>
              <p className="text-gray-500 font-medium">Priority</p>
              <p className="font-bold text-gray-900">{task.priority}</p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <CalendarIcon className="w-8 h-8 text-gray-500" />
            <div>
              <p className="text-gray-500 font-medium">Due Date</p>
              <p className={`font-bold ${isOverdue ? "text-red-600" : "text-gray-900"}`}>
                {formatDate(task.due_date)}
                {isOverdue && <span className="ml-3 text-sm font-bold bg-red-100 text-red-700 px-3 py-1 rounded">OVERDUE</span>}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <UserIcon className="w-8 h-8 text-gray-500" />
            <div>
              <p className="text-gray-500 font-medium">Created By</p>
              <p className="font-bold text-gray-900">{task.creator?.name || "Unknown"}</p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <UserIcon className="w-8 h-8 text-gray-500" />
            <div>
              <p className="text-gray-500 font-medium">Assigned To</p>
              <p className="font-bold text-gray-900">{task.assignee?.name || "Unassigned"}</p>
            </div>
          </div>

          {task.Lead && (
            <div className="flex items-center gap-4 col-span-2">
              <ClipboardDocumentIcon className="w-8 h-8 text-gray-500" />
              <div>
                <p className="text-gray-500 font-medium">Related Lead</p>
                <p className="font-bold text-blue-600 text-xl">
                  {task.Lead.lead_uid} — {task.Lead.name}
                  {task.Lead.mobile && <span className="text-gray-600 ml-3">({task.Lead.mobile})</span>}
                </p>
              </div>
            </div>
          )}

          <div className="flex items-center gap-4">
            <ClipboardDocumentIcon className="w-8 h-8 text-gray-500" />
            <div>
              <p className="text-gray-500 font-medium">Module</p>
              <p className="font-bold text-gray-900">{task.module || "General"}</p>
            </div>
          </div>
        </div>

        {/* Notes */}
        {task.notes && (
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Notes</h3>
            <div className="bg-gray-50 p-6 rounded-xl text-gray-700 text-lg whitespace-pre-line">
              {task.notes}
            </div>
          </div>
        )}

        {/* Approval History */}
        {task.approvals && task.approvals.length > 0 && (
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Approval History</h3>
            <div className="space-y-4">
              {task.approvals.map((approval) => (
                <div key={approval.id} className="bg-gray-50 p-6 rounded-xl">
                  <div className="flex justify-between items-center mb-3">
                    <p className="text-lg font-bold">
                      {approval.approver?.name || "Unknown Approver"}
                    </p>
                    <span className={`px-4 py-2 rounded-full font-bold text-white ${
                      approval.status === "Approved" ? "bg-green-600" :
                      approval.status === "Rejected" ? "bg-red-600" :
                      "bg-amber-600"
                    }`}>
                      {approval.status}
                    </span>
                  </div>
                  {approval.comments && (
                    <p className="text-gray-700 italic">"{approval.comments}"</p>
                  )}
                  <p className="text-sm text-gray-500 mt-3">
                    {approval.decided_at ? new Date(approval.decided_at).toLocaleString() : "Pending"}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}